export const matIcons = [
  'access_time',
  'account_circle',
  'acute',
  'add',
  'add_a_photo',
  'add_circle_outline',
  'add_home',
  'add_photo_alternate',
  'ads_click',
  'apartment',
  'apps',
  'arrow_back',
  'arrow_downward',
  'arrow_drop_down',
  'arrow_drop_up',
  'arrow_forward',
  'arrow_upward',
  'assignment',
  'assignment_ind',
  'attach_money',
  'auto_awesome',
  'badge',
  'ballot',
  'block',
  'border_color',
  'calculate',
  'calendar_add_on',
  'calendar_today',
  'call',
  'call_made',
  'cancel',
  'celebration',
  'chat',
  'chat_paste_go_2',
  'check',
  'check_circle',
  'chevron_left',
  'chevron_right',
  'circle',
  'clear',
  'close',
  'cloud_download',
  'content_copy',
  'content_paste_search',
  'conversion_path',
  'cottage',
  'crop_free',
  'crown',
  'currency_exchange',
  'dashboard',
  'delete',
  'description',
  'directions_car',
  'domain',
  'done',
  'done_all',
  'download',
  'download_for_offline',
  'drag_indicator',
  'draw',
  'east',
  'edit',
  'email',
  'emoji_events',
  'error',
  'event',
  'exit_to_app',
  'expand_less',
  'expand_more',
  'face',
  'fact_check',
  'favorite',
  'filter_hdr',
  'first_page',
  'flag',
  'flash_on',
  'folder',
  'format_list_bulleted',
  'fullscreen',
  'gavel',
  'globe',
  'group',
  'group_add',
  'group_off',
  'handshake',
  'help',
  'help_outline',
  'hide_source',
  'history',
  'home',
  'house',
  'how_to_reg',
  'hub',
  'image',
  'imagesmode',
  'info',
  'insert_drive_file',
  'insert_invitation',
  'ios_share',
  'keyboard_arrow_left',
  'language',
  'leaderboard',
  'lightbulb',
  'link',
  'list',
  'local_atm',
  'location_away',
  'location_on',
  'lock',
  'lock_open',
  'login',
  'mail',
  'map',
  'mark_as_unread',
  'mark_email_read',
  'menu',
  'message',
  'monetization_on',
  'more_horiz',
  'more_vert',
  'no_accounts',
  'north_east',
  'note',
  'notifications',
  'notifications_active',
  'notifications_none',
  'open_in_new',
  'park',
  'pause_circle',
  'payments',
  'pending',
  'people',
  'perm_media',
  'person',
  'person_add',
  'person_cancel',
  'person_check',
  'person_off',
  'person_remove',
  'phone',
  'phone_in_talk',
  'photo_library',
  'pin_drop',
  'place',
  'play_circle',
  'playlist_add_check',
  'policy',
  'post_add',
  'priority_high',
  'progress_activity',
  'public',
  'publish',
  'qr_code_2',
  'real_estate_agent',
  'receipt',
  'refresh',
  'remove',
  'report_problem',
  'rocket_launch',
  'save',
  'schedule',
  'search',
  'send',
  'sentiment_neutral',
  'sentiment_satisfied',
  'sentiment_satisfied_alt',
  'sentiment_very_satisfied',
  'settings',
  'share',
  'shopping_bag',
  'show_chart',
  'sms',
  'sort',
  'south_west',
  'speed',
  'star',
  'store',
  'supervisor_account',
  'swap_horiz',
  'sync',
  'task_alt',
  'textsms',
  'thumb_up',
  'timelapse',
  'timeline',
  'trending_up',
  'tune',
  'undo',
  'unfold_less',
  'unfold_more',
  'upload',
  'videocam',
  'view_stream',
  'visibility',
  'visibility_off',
  'volcano',
  'warning',
  'west',
  'workspace_premium',
  'zoom_in',
  'zoom_out',
] as const;

export type MaterialIcons = (typeof matIcons)[number];
